const clearAllCaches = async () => {
  const WORKBOX_PRECACHE_NAME = 'workbox-precache-v2';

  if ('caches' in window) {
    const cacheNames = await caches.keys();

    const cacheToDelete = cacheNames.find((name) => name.includes(WORKBOX_PRECACHE_NAME));

    cacheToDelete && (await caches.delete(cacheToDelete));
  }
};

const unregisterServiceWorkers = async () => {
  if ('serviceWorker' in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();

    await Promise.all(regs.map((reg) => reg.unregister()));
  }
};

export const cleanPrecacheAndUnregisterServiceWorkers = async () => {
  await clearAllCaches();

  await unregisterServiceWorkers();
};
